import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/css/sidebar.css'; 
import { useOverviewContext } from '../context/OverviewContext';
import { useToolSettings } from '../context/ToolSettingsContext';
import { getActiveToolIDs, isRouteAccessible, shouldShowK12Zone, shouldShowLearningCoachCommunity } from '../utils/menuUtils';
import { useLinksContext } from '../context/LinksContext'; 
interface SidebarMenusListProps {
    bgColor:string;
    textColor1: string;
    textColor2: string;
    textColor3: string;
    isMobile:boolean;
}

export const SidebarMenusList: React.FC<SidebarMenusListProps> = ({
    bgColor,
    textColor1,
    textColor2,
    textColor3,
    isMobile,
  }) => {

    // const [schoolPrepOpen, setSchoolPrepOpen] = useState(false);
    // const [coachLifeOpen, setCoachLifeOpen] = useState(false);
    // const [onlineSchoolOpen, setOnlineSchoolOpen] = useState(false);
    
    const [openMenu, setOpenMenu] = useState<string | null>(null);
    const toggleMenu = (menuName: string) => {
      console.log(menuName);
      setOpenMenu(openMenu === menuName ? null : menuName);
    };
    
    const { myAccountLink, olsLink } = useLinksContext();
    const getAccountLink = () => {
        try {
          if (!myAccountLink) {
            console.warn("My Account link is missing."); 
            return;
          }
          const cleanUrl = myAccountLink.trim().replace(/^"|"$/g, "");  
          window.open(cleanUrl, "_blank");
        } catch (error) {
          console.error("Failed to open My Account link:", error);
        }
    };

    // UserRole & Check if any student is in Elementary or Middle School in LC login 
    const {userRoleVal, hasNonHighSchoolStudents} = useOverviewContext();
    
    // Get tool settings from context
    const { toolSettings } = useToolSettings();
    const activeToolIDs = getActiveToolIDs(toolSettings);
    const showLearningCoachCommunity = shouldShowLearningCoachCommunity(userRoleVal, activeToolIDs);
    const showK12Zone = shouldShowK12Zone(userRoleVal, activeToolIDs);

    // console.log(userRoleVal, showLearningCoachCommunity, showK12Zone);
    // console.log(hasNonHighSchoolStudents);

    return (
        <nav className="main-menu-container primary-menu">
            <ul className="menu">
                <li className="menu-item menu-icon-overview">
                    <NavLink
                    to="/"
                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor1}`}
                    >
                    <span>Overview</span> 
                    </NavLink>
                </li>
                <li className="menu-item menu-icon-checklist">
                    <NavLink
                    to="/school-prep-checklist"
                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor1}`}
                    >
                    <span> School Prep Checklist </span>
                    </NavLink>
                
                    <ul className="inner-menu-list">
                    {userRoleVal != "STUDENT" && ( 
                        <li className="menu-item">
                            {/* <a className={`submenu-head ${textColor2}`}  onClick={() => setSchoolPrepOpen(!schoolPrepOpen)}
                                >
                                Forms & Documents
                                <i className={`fas ${schoolPrepOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                            </a> */}
                            <a className={`submenu-head ${textColor2}`} onClick={() => toggleMenu('formsdocs')}>
                                Forms & Documents
                                <i className={`fas ${openMenu === 'formsdocs' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                            </a>

                            {openMenu === 'formsdocs' && (
                            <ul className="submenu-item">
                                <li>
                                <NavLink
                                    to="/k12-checklist-category/forms-and-documents/"
                                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                >
                                    <b>View All</b>
                                </NavLink>
                                </li>
                                <li>
                                <NavLink
                                    to="/k12-checklist/school-documents/"
                                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                >
                                    School Documents
                                </NavLink>
                                </li>
                                {/* Grade Logic - School for students */}
                                {userRoleVal !== "STUDENT" && hasNonHighSchoolStudents && (
                                    <li>
                                    <NavLink to="/k12-checklist/consent-process"
                                        className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                    >
                                        Consent Process
                                    </NavLink>
                                    </li>
                                )}
                            </ul>
                            )}
                        </li>
                    )}

                    {userRoleVal != "STUDENT" && ( 
                        <li className="menu-item">
                            {/* <a className={`submenu-head ${textColor2}`} onClick={() => setCoachLifeOpen(!coachLifeOpen)}
                                >
                                Learning Coach Life
                                <i className={`fas ${coachLifeOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                            </a> */}

                            <a className={`submenu-head ${textColor2}`} onClick={() => toggleMenu('coachlife')}> Learning Coach Life
                            <i className={`fas ${openMenu === 'coachlife' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                            </a>
                            {openMenu === 'coachlife'&& (
                                <ul className="submenu-item">
                                {isRouteAccessible(userRoleVal, '/k12-checklist-category/learning-coach-life/') && (
                                    <li>
                                    <NavLink
                                        to="/k12-checklist-category/learning-coach-life/"
                                        className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                    >
                                        <b>View All</b>
                                    </NavLink>
                                    </li>
                                )}

                                {isRouteAccessible(userRoleVal,'/k12-checklist/what-is-a-learning-coach/') && (
                                    <li>
                                    <NavLink
                                        to="/k12-checklist/what-is-a-learning-coach/"
                                        className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                    >
                                        What is a Learning Coach?
                                    </NavLink>
                                    </li>
                                )}
                                {isRouteAccessible(userRoleVal,'/k12-checklist/what-does-a-learning-coach-do/') && (
                                    <li>
                                    <NavLink
                                        to="/k12-checklist/what-does-a-learning-coach-do/"
                                        className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                    >
                                        What does a Learning Coach do?
                                    </NavLink>
                                    </li>
                                )}
                                </ul>
                            )}
                        </li>
                    )}

                        <li className="menu-item">
                            <a className={`submenu-head ${textColor2}`} onClick={() => toggleMenu('onlineschool')}>
                            Online School
                            <i className={`fas ${openMenu === 'onlineschool' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                            </a>

                            {openMenu === 'onlineschool' && (
                            <ul className="submenu-item">
                                <li>
                                <NavLink
                                    to="/k12-checklist-category/online-school/"
                                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                >
                                    <b>View All</b>
                                </NavLink>
                                </li>
                                <li>
                                <NavLink
                                    to="/k12-checklist/school-start-faqs/"
                                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                >
                                    School Start FAQs
                                </NavLink>
                                </li>
                                <li>
                                {/* Feedback */}
                                <NavLink
                                    to="/k12-checklist/navigating-the-online-school/"
                                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                >
                                    Navigating the Online School
                                </NavLink>
                                </li>
                                <li>
                                <NavLink
                                    to="/k12-checklist/sample-lessons/"
                                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                >
                                    Sample Lessons
                                </NavLink>
                                </li>
                            </ul>
                            )}
                        </li>
                        <li className="menu-item">
                            <a className={`submenu-head ${textColor1}`} onClick={() => toggleMenu('emailsetup')}>
                            Email Setup
                            <i className={`fas ${openMenu === 'emailsetup' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                            </a>

                            {openMenu === 'emailsetup' && (
                            <ul className="submenu-item">
                                <li>
                                <NavLink
                                    to="/k12-checklist-category/email-setup/"
                                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                >
                                    <b>View All</b>
                                </NavLink>
                                </li>
                                <li>
                                <NavLink
                                    to="/k12-checklist/email-basics/"
                                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                >
                                    Email Basics
                                </NavLink>
                                </li>
                                <li>
                                <NavLink
                                    to="/k12-checklist/email-options/"
                                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor3}`}
                                >
                                    Email Options
                                </NavLink>
                                </li>
                                
                            </ul>
                            )}
                        </li>

                    </ul>
                </li>
                <li className="menu-item menu-icon-learning">
                    <NavLink
                    to="/learning-materials"
                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor1}`}
                    >
                    Learning Materials
                    </NavLink>
                </li>
                {/* restricted Logic */}
                {isRouteAccessible(userRoleVal, "/community") && (
                    <li className="menu-item menu-icon-community">
                        <NavLink
                            to="/community"
                            end // Prevents it from getting active when submenu is clicked
                            className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor2}`}
                        >
                            Community
                        </NavLink>

                        <ul className="inner-menu-list">
                            {/* Learning Coach Community - Only for LC Role, Tool ID 128 or 166 must be active */}
                            {isRouteAccessible(userRoleVal, "/community/learning-coach-community") && showLearningCoachCommunity && (
                                <li className="menu-item">
                                    <NavLink
                                        to="/community/learning-coach-community"
                                        className={({ isActive }) => (isActive ? 'active' : '')} // Applies active only to this item
                                    >
                                        Learning Coach Community
                                    </NavLink>
                                </li>
                            )}

                            {/* K12 Zone - For LC or Student Role, Tool ID 182 must be active */}
                            {isRouteAccessible(userRoleVal, "/community/k12-zone") && showK12Zone && (
                                <li className="menu-item">
                                    <NavLink
                                        to="/community/k12-zone"
                                        className={({ isActive }) => (isActive ? 'active' : '')} // Applies active only to this item
                                    >
                                        Hang Out in the K12 Zone
                                    </NavLink>
                                </li>
                            )}

                        </ul>
                    </li>
                )}

                <li className="menu-item d-block d-md-none">
                    <NavLink to="#" onClick={getAccountLink} >
                        My Account
                    </NavLink>
                </li>
                <li className="menu-item menu-icon-contact">
                    <NavLink
                    to="/contact"
                    className={({ isActive }) => `${isActive ? 'active' : ''} ${textColor1}`}
                    >
                    Contact
                    </NavLink>
                </li>
            </ul>
        </nav>
    )
};
